import React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { InputBaseProps } from "@mui/material/InputBase/InputBase";

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 10,
    position: "relative",
    backgroundColor: "#242A2F",
    border: "1px solid",
    borderColor: "#242A2F",
    fontSize: 14,
    width: "100%",
    padding: "16px",
    color: "#fff",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      // borderColor: theme.palette.primary.main,
    },
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
      borderColor: "#2D3843",
    }),
  },
}));

interface TextFeildInterface extends InputBaseProps {
  label?: string;
  name?: string;
  id?: string;
  type?: string;
  className?: string;
  placeholder?: string;
  value?: any;
  onChange?: any;
  required?: boolean;
  disabled?: boolean;
}
const CustomTextField = ({
  label,
  placeholder,
  className,
  type,
  name,
  value,
  onChange,
  required,
  disabled = false,
  ...rest
}: TextFeildInterface) => {
  return (
    <FormControl variant="standard" className={"w-full"}>
      <InputLabel
        shrink
        htmlFor="bootstrap-input"
        className={"text-primaryText"}
      >
        {label}
      </InputLabel>
      <BootstrapInput
        className={`w-full bg-gray text-primaryText rounded-2xl ${className}`}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        required={required}
        disabled={disabled}
        {...rest}
      />
    </FormControl>
  );
};
export default CustomTextField as React.FC<TextFeildInterface>;
